import _ from 'underscore';
import { edmCampaign } from '@bingads-webui/edm-campaign';

export class InvestImageDataService {
  constructor({ cid, aid }) {
    this.cid = cid;
    this.aid = aid;
  }

  /**
   * Get the invest images or videos using edmCampaign
   *
   * @param {Object} options - options for getting
   * @param {Number} options.top - top
   * @param {Number} options.skip - skip
   * @param {Object} options.customQueries - key value pair for the additional queries.
   *
   * @returns {Promise} - Promise of getting the images
   */
  getInvestAssets(options) {
    const defaultOptions = {
      top: 20,
      skip: 0,
      customQueries: {},
    };

    const optionsWithDefault = _.defaults(options, defaultOptions);

    const payload = _.extend({
      $top: optionsWithDefault.top,
      $skip: optionsWithDefault.skip,
    }, optionsWithDefault.customQueries);

    const edm = edmCampaign
      .Customers
      .$withKey(this.cid)
      .Accounts
      .$withKey(this.aid)
      .XandrAssets;

    return edm.get(payload).toPromise();
  }

  /**
   * Upload the invest video using edmCampaign
   *
   * @param {Object} options - options for the asset payload
   * @param {String} options.Url - the video url
   * @param {Number} options.XandrAssetId - the invest video id
   * @param {String} options.Description - desription
   *
   * @returns {Promise} - Promise of uploading the video
   */
  addInvestVideoAsset(options) {
    const payload = {
      Asset: {
        '@odata.type': '#Model.Video',
        SourceType: 'XandrImported',
        Url: options.Url,
        XandrAssetId: options.XandrAssetId,
        Description: options.Description,
      },
      FolderId: null,
    };

    const edm = edmCampaign
      .Customers.$withKey(this.cid)
      .Accounts.$withKey(this.aid)
      .Folders['Default.AddAsset'];

    return edm.$makeCall({ payload }).toPromise();
  }
}
